import { createContext } from 'react'

import { ID } from '@s4l/stayforlong/kernel/ID'
import { ListOfAvailability } from '@s4l/stayforlong/booking/ListOfAvailability'
import { DateRange } from '@s4l/stayforlong/booking/DateRange'

interface RoomConfiguratorContextType {
  roomID: ID
  listOfAvailability: ListOfAvailability
  isMultiBooking: boolean
}

export const RoomConfiguratorContext = createContext<RoomConfiguratorContextType>({
  listOfAvailability: ListOfAvailability.create({
    list: [],
    dateRange: DateRange.default(),
  }),
  roomID: ID.create({ value: '' }),
  isMultiBooking: false,
})
